import SessionTimeOut from './SessionTimeOut';

export default SessionTimeOut;
